import request from '../../config/axiosConfig';
import {
  GET_LIST_OBJECT_TYPES, CREATE_OBJECT_TYPE, UPDATE_OBJECT_TYPE,
  DELETE_OBJECT_TYPE, LIST_ACTIVE_OBJECT_TYPES
} from '../../constants/apiEndPoint';

const objectTypeService = {
  // Controller đọc limit/page/từ khóa từ req.body (validator đóng) nên phải gửi body whitelist,
  // và map từ khóa chung "search" của CrudPage sang đúng key "name" API nhận
  getList: async (params = {}) => {
    const { page = 1, limit = 10, search, name } = params;
    const body = { page, limit };
    const term = name ?? search;
    if (term) body.name = term;
    const { data } = await request({ url: GET_LIST_OBJECT_TYPES, method: 'POST', data: body });
    return data;
  },
  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_OBJECT_TYPE, method: 'POST', data: dataBody });
    return data;
  },
  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_OBJECT_TYPE, method: 'POST', data: { id, ...dataBody } });
    return data;
  },
  delete: async (id) => {
    const { data } = await request({ url: DELETE_OBJECT_TYPE, method: 'POST', data: { id } });
    return data;
  },
  listActive: async () => {
    const { data } = await request({ url: LIST_ACTIVE_OBJECT_TYPES, method: 'POST' });
    return data?.data || data;
  },
};

export default objectTypeService;
